module.exports = __webpack_public_path__ + "static/media/hero_mobile.06c42044.webp";